import gql from 'graphql-tag'

export const REGISTER_SHOP = gql`
  mutation ($input: RegisterShopInput!) {
    registerShop(input: $input) {
      errors
      shop {
        id
      }
    }
  }
`

export default {
  REGISTER_SHOP
}
